import { inject } from '@angular/core';
import { FormConfig } from '../edit-create-form.interfaces';
import { AddressItemApiService } from '@shared/services/address-item-api.service';
import { ADDRESS_ITEM_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const addressItemFormConfig = (): FormConfig => {
  const addressItemApiService = inject(AddressItemApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'name', label: 'Tên', required: true, width: 'full',
        type: 'text', placeholder: 'Nhập tên địa chỉ'
      },
      {
        key: 'type', label: 'Loại', required: true, width: 'half',
        type: 'select',
        config: {
          staticOptions: [
            { label: 'Tỉnh/Thành phố', value: 'PROVINCE' },
            { label: 'Quận/Huyện', value: 'CITY' },
            { label: 'Phường/Xã', value: 'WARD' }
          ],
          optionLabel: 'label',
          optionValue: 'value',
          placeholder: 'Chọn loại địa chỉ'
        }
      },
      {
        key: 'legacy', label: 'Legacy', width: 'half',
        type: 'toggleSwitch', placeholder: 'Trước chuyển đổi 2025?'
      },
      {
        key: 'refId', label: 'Ref ID (Tỉnh/Quận cha)', width: 'full',
        type: 'select',
        config: {
          ...ADDRESS_ITEM_SELECT_CONFIG,
          service: addressItemApiService
        }
      }
    ]
  };
};

